import { Avatar, AvatarGroup, Button, Divider, Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react'
import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(LocalizedFormat)

export default function DocSidebarContentAnalytics({ onClose, doc, variant }) {
  const [analytics, setAnalytics] = useState<{ [value: string]: { section: any; data: any[] } }>({})
  const [loading, setLoading] = useState<boolean>(false)
  const setupAnalytics = () => {
    const sections = doc?.[variant].sections
    const stats: { [value: string]: { section: any; data: any[] } } = {}
    for (const section of sections) {
      stats[section.uuid] = {
        section,
        data: doc.analytics?.filter((item: any) => item.variant === variant && item.sections?.includes(section.uuid)),
      }
    }
    setAnalytics(stats)
    setLoading(false)
  }
  const [activeAnalytics, setActiveAnalytics] = useState<any>({})
  const [popOverData, setPopOverdata] = useState<any[]>([])
  useEffect(() => {
    setupAnalytics()
  }, [doc])
  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col sticky top-0 bg-white">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-medium">Inspection</h2>
          <Button isIconOnly variant="light" onPress={onClose} size="sm">
            <Icon icon="ic:round-close" className="text-gray-500 text-xl" />
          </Button>
        </div>
        <Divider className="my-2 h-[3px]" />
      </div>

      <div className="flex flex-col justify-between items-center mb-4">
        <div className="w-full">
          <div className="flex justify-between items-center mb-4">VIEWER TRACKING</div>
          <div className={'flex gap-2 flex-col flex-1 border-1 border-default p-2'}>
            {Object.keys(analytics).map((key: string) => {
              const { section, data } = analytics[key]
              return (
                <div className={'flex flex-row items-center gap-4 justify-between'}>
                  <div>
                    <Button
                      color={data.length > 0 ? 'secondary' : 'default'}
                      className="whitespace-normal break-words w-full h-fit min-h-[35px] max-w-[100%] text-xs"
                    >
                      {section.title}
                    </Button>
                  </div>
                  <div className={'cursor-pointer'}>
                    <Popover
                      placement="bottom"
                      showArrow={true}
                      onOpenChange={() => {
                        setActiveAnalytics(data?.[0] ?? {})
                        setPopOverdata(data)
                      }}
                    >
                      <PopoverTrigger>
                        <AvatarGroup isBordered max={3} total={data.length - 1} size={'sm'}>
                          {data.map((item: any) => (
                            <Avatar name={item.username} key={item.username} size={'sm'} />
                          ))}
                        </AvatarGroup>
                      </PopoverTrigger>
                      <PopoverContent>
                        <div className="px-1 py-2 min-w-[150px]">
                          <div className={'flex flex-row gap-3 pt-2 pb-2'}>
                            {data.map((item: any) => (
                              <Avatar
                                className={'cursor-pointer'}
                                name={item.username}
                                key={item.username}
                                size={'sm'}
                                onClick={() => setActiveAnalytics(item)}
                                isBordered={true}
                                color={item.id === activeAnalytics?.id ? 'secondary' : 'default'}
                              />
                            ))}
                          </div>
                          <Divider orientation="horizontal" />
                          <div className={'pt-2 pb-2'}>
                            <p className={'text-sm font-bold'}>@{activeAnalytics?.username}</p>
                            <p className={'text-xs'}>First Opened</p>
                            <span className={'text-default-400'}>{dayjs(activeAnalytics?.openDate).format('lll')}</span>
                          </div>
                          <Divider orientation="horizontal" />
                          <div className={'pt-2 pb-2'}>
                            <p className={'text-xs'}>Last Open</p>
                            <span className={'text-default-400'}>{dayjs(activeAnalytics?.lastOpen).format('lll')}</span>
                          </div>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
